import { useState, useEffect } from 'react';
import { FoodFactResponse } from '@/services/foodFactService';
import { foodFactService } from '@/services/foodFactService';

export const useFoodFacts = (category?: string, searchQuery?: string) => {
    const [foodFacts, setFoodFacts] = useState<FoodFactResponse[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchFoodFacts = async () => {
        try {
            setLoading(true);
            setError(null);

            let facts: FoodFactResponse[];

            if (searchQuery && searchQuery.trim()) {
                // Búsqueda
                facts = await foodFactService.searchFoodFacts(searchQuery);
            } else if (category && category !== 'TODOS') {
                // Por categoría
                facts = await foodFactService.getFoodFactsByCategory(category);
            } else {
                // Todos los facts activos
                facts = await foodFactService.getAllFoodFacts();
            }

            setFoodFacts(facts);
        } catch (err: any) {
            setError(err.message || 'Error al cargar los datos nutricionales');
            console.error('Error fetching food facts:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFoodFacts();
    }, [category, searchQuery]);

    return {
        foodFacts,
        loading,
        error,
        refetch: fetchFoodFacts
    };
};